import HSelectTree from './HSelectTree.vue'

// 为组件提供 install 安装方法，供按需引入
HSelectTree.install = function (Vue) {
    Vue.component(HSelectTree.name, HSelectTree)
}
  
// 默认导出组件
export default HSelectTree